import { MerchantActionType as actionType } from '../actions/action';
import { MerchantAction } from '../actions/action.creators';
import { InitialMerchantState } from '../state/state';

const merchants = (state = InitialMerchantState, action: MerchantAction) => {
    switch (action.type) {
        case actionType.SET_ADD_NEW_BUSINESS_ERROR:
            state = { ...state, addNewBusinessError: action.payload };
            break;
        case actionType.SET_ONBOARDING_PROFILE:
            state = { ...state, onBoardingProfile: action.payload };
            break;
        case actionType.SET_KYC_TYPES:
            state = { ...state, kycTypes: action.payload };

            break;
        case actionType.SET_KYC_STATUS:
            state = { ...state, kycStatus: action.payload };

            break;
        case actionType.SET_MERCHANT_PROFILE:
            state = { ...state, merchantProfile: action.payload };
            break;
        case actionType.SET_MERCHANT_DETAILS:
            state = { ...state, merchantDetails: action.payload };
            break;
        case actionType.SET_MERCHANTS_CATEGORY:
            state = { ...state, merchantCategory: action.payload };
            break;
        case actionType.GET_LIVE_MERCHANT_CATEGORIES:
            return { ...state, merchantLiveCategories: action.payload };
        case actionType.SET_ALL_BUSINESS_TYPES:
            state = { ...state, businessTypes: action.payload };
            break;
        case actionType.TOGGLING_APP_MODE:
            return { ...state, isTogglingAppMode: true };
        case actionType.TOGGLING_APP_MODE_SUCCESS:
            return {
                ...state,
                isTogglingAppMode: false,
                isTogglingAppModeSuccess: true,
                toggledAppMode: action.payload
            };
        case actionType.TOGGLING_APP_MODE_FAILURE:
            return {
                ...state,
                isTogglingAppMode: false,
                isTogglingAppModeSuccess: false,
                isTogglingAppModeFailure: true,
                error: action.payload
            };
        case actionType.GET_MODE_TYPE:
            return { ...state, modeTypeFetching: true };
        case actionType.GET_MODE_TYPE_SUCCESS:
            return { ...state, modeTypeFetching: false, modeTypeSuccess: true };
        case actionType.GET_MODE_TYPE_FAILURE:
            return {
                ...state,
                modeTypeFetching: false,
                modeTypeSuccess: false,
                modeTypeFailure: true,
                error: action.payload
            };
        case actionType.GET_INVITATION_SUCCESS:
            return { ...state, invitations: action.payload };
        case actionType.GET_INVITATION_FAILURE:
            return { ...state, error: action.payload };
        case actionType.GET_LIVE_MERCHANT_SUCCESS:
            return { ...state, getLiveMerchantSuccess: true, getLiveMerchantFailure: false };
        case actionType.GET_LIVE_MERCHANT_FAILURE:
            return { ...state, getLiveMerchantSuccess: false, getLiveMerchantFailure: true };
        case actionType.CREATING_MERCHANT_LIVE_ACCOUNT:
            return { ...state, creatingMerchantLiveAccount: true };
        case actionType.CREATING_MERCHANT_LIVE_ACCOUNT_SUCCESS:
            return {
                ...state,
                creatingMerchantLiveAccount: false,
                creatingMerchantLiveAccountSuccess: true,
                getLiveMerchantSuccess: true
            };
        case actionType.CREATING_MERCHANT_LIVE_ACCOUNT_FAILURE:
            return {
                ...state,
                creatingMerchantLiveAccount: false,
                creatingMerchantLiveAccountSuccess: false,
                creatingMerchantLiveAccountFailure: action.payload
            };
        case actionType.TWO_FA_SETUP:
            return { ...state, twoFaLoading: true, twoFaError: null };

        case actionType.TWO_FA_SETUP_SUCCESS:
            return {
                ...state,
                twoFaLoading: false,
                twoFaSetupData: action.payload,
                twoFaError: null
            };

        case actionType.TWO_FA_SETUP_FAILURE:
            return {
                ...state,
                twoFaLoading: false,
                twoFaError: action.payload
            };

        case actionType.TWO_FA_ENABLE:
            return { ...state, twoFaLoading: true, twoFaError: null };

        case actionType.TWO_FA_ENABLE_SUCCESS:
            return {
                ...state,
                twoFaLoading: false,
                twoFaError: null
            };

        case actionType.TWO_FA_ENABLE_FAILURE:
            return {
                ...state,
                twoFaLoading: false,
                twoFaError: action.payload
            };

        case actionType.TWO_FA_STATUS:
            return { ...state, twoFaLoading: true, twoFaError: null };

        case actionType.TWO_FA_STATUS_SUCCESS:
            return {
                ...state,
                twoFaLoading: false,
                twoFaStatusData: action.payload,
                twoFaError: null
            };

        case actionType.TWO_FA_STATUS_FAILURE:
            return {
                ...state,
                twoFaLoading: false,
                twoFaError: action.payload
            };

        case actionType.TWO_FA_DISABLE:
            return { ...state, twoFaLoading: true, twoFaError: null };

        case actionType.TWO_FA_DISABLE_SUCCESS:
            return {
                ...state,
                twoFaLoading: false,
                twoFaSetupData: null,
                twoFaStatusData: { is2faEnabled: false },
                twoFaError: null
            };

        case actionType.TWO_FA_DISABLE_FAILURE:
            return {
                ...state,
                twoFaLoading: false,
                twoFaError: action.payload
            };
        default:
            break;
    }
    return state;
};

export default merchants;
